// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1LpXc","col":"Table_col__gpydL","fulfillmentStatus":"Table_fulfillmentStatus__bFBmM","emailCol":"Table_emailCol__tqAOr"};